import React from 'react';
import ReactDom from 'react-dom';
import userSetAction from '../../actions/userSetAction';

class TeamCreateModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            team: [],
            warningMsg: "",
            teamName: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {

    }
    handleChange(e) {
        let value = e.target.value;
        this.setState({
            teamName: value
        });
    }
    handleKeyPress(e){
        if(e.key == 'Enter'){
            e.preventDefault();
            this.handleClick();
        }
    }
    handleClick(e) {
        //update to server
        let action = this.props.action;
        if (action == 0) {
            let team = this.props.team;
            if (this.state.teamName == "") {
                return this.setState({ warningMsg: "Team Name cannot be empty" });
            }
            team.push({
                teamName: this.state.teamName,
                teamMember:[]
            });
            userSetAction.team(team);
        }else{
            //push to removedTeam if have id
            if(this.props.team[this.props.index]._id){
                let removedTeam = this.props.removedTeam;
                removedTeam.push(this.props.team[this.props.index]._id);
                userSetAction.removedTeam(removedTeam);
            }

            let team = this.props.team;
            team.splice(this.props.index,1);
            userSetAction.team(team);
        }
        this.props.shouldModalClose(false);
    }

    modalClose() {
        this.props.shouldModalClose(false);
    }



    renderContent() {
        if (this.props.action == 0) {
            return (
                <div>
                    <form >
                        <div className="form-group">
                            <label htmlFor="teamName">Team Name:</label>
                            <input type="text" className="form-control" id="teamName" placeholder="Type New Team Name"
                                onChange={this.handleChange} onKeyPress={this.handleKeyPress}/>
                        </div>
                    </form>
                </div>
            )
        } else {
            return (
                <div>
                    Are you sure to remove {this.props.team[this.props.index].teamName}?
                </div>
            )
        }

    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }} ref="modal">
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" style={{ height: (this.state.clientHeight - 115) + "px" }}>
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn " + (this.props.action == 0 ? "btn-info" : "btn-warning")}
                            onClick={this.handleClick}>
                            {this.props.action == 0 ? "Create" : "Remove"}
                        </button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default TeamCreateModal;


// WEBPACK FOOTER //
// ./app/setComponents/userSetComponents/teamCreateModal.js